import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/svg/pattern.svg");
;
import(/* webpackMode: "eager", webpackExports: ["CancelRulesBody"] */ "/app/src/containers/website/helpCenter/cancel-rules/CancelRulesBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/shared/components/common/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/input/Input.tsx");
